module.exports = __webpack_public_path__ + "static/media/training_quote.9b57cddc.jpg";